import request from '../../../helpers/request';

const addTenant = async (values, tenantName, isEdit = false) => {
  const response = await request.post(
    `/HousingStock/client`,
    values,
    `При ${
      isEdit ? 'изменении' : 'добавлении'
    } жильца ${tenantName} произошла ошибка`
  );

  return response;
};

export default addTenant;
